import { TextField } from "../../../ui/index.ts";
import { Card } from "../../../shared/card/card.tsx";
import formStyles from "../../hr-setup/tabs/hr-approve-tab.module.css";
import styles from "./consultant-queue-details.module.css";

const SECTIONS = [
  { title: "Consultant Details", fields: { firstName: "First Name", lastName: "Last Name", preferredName: "Preferred Name", ccEmail: "Official Email", phoneNumber: "Contact Number"} },
  { title: "Agency Details", fields: { agencyLegalCompanyName: "Legal Company Name", agencyDbaName: "DBA Name", agencyPrimaryContactName: "Primary Contact", agencyContactTitle: "Contact Title", agencyEmail: "Agency Email", agencyPhone: "Agency Phone", agencyBusinessAddress: "Business Address", agencyTaxId: "Tax ID" } },
  { title: "Agency Payment Details", fields: { agencyAccountNumber: "Account Number", agencyBankName: "Bank Name", agencyRoutingNumber: "Routing Number", agencySwiftCode: "SWIFT Code", agencyPaymentMethod: "Payment Method", agencyPaymentTerms: "Payment Terms" } },
];
const LABELS: Record<string, string> = { INDIAN_CONSULTANT: "Indian Consultant", DIRECT: "US Direct Consultant", VENDOR_BASED: "US Vendor Based Consultant", ACH_DIRECT_DEPOSIT: "ACH / Direct Deposit", WIRE_TRANSFER: "Wire Transfer", NET_15: "Net 15", NET_30: "Net 30", NET_45: "Net 45" };

const CONTACT_FIELDS = new Set(["email", "phone", "agencyPrimaryContactName", "agencyContactTitle", "agencyEmail", "agencyPhone", "agencyBusinessAddress", "caeliusProjectContact"]);

export function ConsultantQueueDetails({
  employee,
  section,
}: {
  employee: Record<string, unknown>;
  section?: "personal" | "contact";
}) {
  return (
    <div className={styles.sections}>
      {SECTIONS
        .filter(
          (section) =>
            !section.title.startsWith("Agency") || employee.agencyId != null
        )
        .map(({ title, fields }) => ({
          title,
          fields: Object.entries(fields).filter(
            ([key]) =>
              (key !== "preferredName" ||
                employee.consultantType !== "INDIAN_CONSULTANT") &&
              (!section ||
                (section === "contact"
                  ? CONTACT_FIELDS.has(key)
                  : !CONTACT_FIELDS.has(key)))
          ),
        }))
        .filter(({ fields }) => fields.length > 0)
        .map(({ title, fields }) => (
          <section key={title}>
            <Card className={formStyles.readOnlyRow}>
              {fields.map(([key, label]) => {
                const value =
                  employee[key] ??
                  (key === "email"
                    ? employee.personalEmail
                    : key === "phone"
                      ? employee.phoneNumber
                      : undefined);

                return (
                  <TextField
                    key={key}
                    id={`consultant-detail-${key}`}
                    label={label}
                    value={
                      value == null || value === ""
                        ? "Not provided"
                        : LABELS[String(value)] ?? String(value)
                    }
                    readOnly
                    disabled
                  />
                );
              })}
            </Card>
          </section>
        ))}
    </div>
  );
}
